import { useState } from "react";
import {
  iconNext,
  imgLC1,
  imgLC2,
  imgLC3,
  imgLC4,
  imgLC5,
  imgLC6,
  imgLC7,
  imgLC8,
  imgLC9,
  imgLC10,
  imgLC11,
  imgLC12,
  imgLC13,
  imgLC14,
  imgLC15,
  imgLC16,
  imgLC17,
  imgLC18,
  imgLC19,
  imgLC20,
  imgLC21,
  imgLC22,
  imgLC23,
  imgLC24,
  imgLC25,
  imgLC26,
  imgLC27,
  imgLC28,
  imgLC29,
  imgLC30,
  imgLC31,
} from "../assets";

const LifeProContent = ({
  treatmentRef,
  cultureRef,
  prizeRef,
  promotionPathRef,
  trainingRef,
}) => {
  const [idData, setIdData] = useState(1);

  const scrollTo = (value) => {
    if (value === "CHẾ ĐỘ ĐÃI NGỘ") {
      treatmentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
      return;
    }
    if (value === "MÔI TRƯỜNG LÀM VIỆC") {
      cultureRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
      return;
    }
    if (value === "GIẢI THƯỞNG") {
      prizeRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
      return;
    }
    if (value === "LỘ TRÌNH THĂNG TIẾN") {
      promotionPathRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
      return;
    }
    if (value === "HUẤN LUYỆN ĐÀO TẠO") {
      trainingRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "center",
      });
      return;
    }
  };

  const action = (value) => {
    if (value === "left") {
      setIdData((preState) => (preState === 0 ? 30 : preState - 1));
    }
    if (value === "right") {
      setIdData((preState) => (preState === 30 ? 0 : preState + 1));
    }
  };

  return (
    <div className="w-screen h-auto relative flex items-center flex-col pb-[80px]">
      <div className="h-auto w-screen">
        <div className={`bg-white flex flex-col items-center`}>
          <div className="font-[700] text-[#333333] text-[26px] sm:text-[30px] lg:text-[36px] border-b-[6px] pb-[15px] w-fit border-[#005DD7] mb-[30px] mt-[40px] text-center mx-[20px]">
            GIÁ TRỊ CỦA LIFE PRO MANG LẠI
          </div>
          <div className=" lg:w-[1116px] flex justify-center h-auto flex-wrap gap-[20px] mb-[10px]">
            {dataScroll.map((item, index) => (
              <div
                key={index}
                className="font-[500] text-[#005dd7] text-[14px] sm:text-[20px] h-[40px] sm:h-[55px] w-[161px] sm:w-[246px] lg:w-[356px] flex rounded-[20px] border border-[#005DD7] justify-center items-center cursor-pointer"
                onClick={() => scrollTo(item)}
              >
                <span className="text-center w-[116px] leading-[16px] sm:leading-none sm:w-auto ">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-screen lg:w-[1116px] relative flex justify-center h-[204px] sm:h-[257px] lg:h-[353px] mt-[60px] sm:w-[inherit]">
        <img
          src={iconNext}
          alt=""
          className="absolute top-[50%] left-[12px]  z-[5] rotate-180 translate-y-[-50%] h-[40px] sm:h-[60px] cursor-pointer"
          onClick={() => action("left")}
        />
        <img
          src={iconNext}
          alt=""
          className="absolute top-[50%] right-[12px] z-[5] translate-y-[-50%] h-[40px] sm:h-[60px] cursor-pointer"
          onClick={() => action("right")}
        />
        <div className="absolute left-[50%] translate-x-[-50%] flex items-center justify-center overflow-hidden py-[15px]">
          <div className="flex w-[174px] h-[104px] sm:w-[227px] sm:h-[136px] lg:w-[319px] lg:h-[191px]  min-h-[104px] sm:min-w-[227px] sm:min-h-[136px] lg:min-w-[319px] lg:min-h-[191px]  rounded-[10px] z-[1] overflow-hidden mr-[-15px]">
            <img
              className="object-cover w-full h-full rounded-[10px] brightness-[0.65]"
              src={dataUser[idData === 0 ? 30 : idData - 1].img}
              alt=""
            />
          </div>
          <div className="flex box-shadow w-[295px] h-[174px] sm:w-[385px] sm:h-[227px] lg:w-[546px] lg:h-[323px] min-w-[295px] min-h-[174px] sm:min-w-[385px] sm:min-h-[227px] lg:min-w-[546px] lg:min-h-[323px] rounded-[10px] border-[2px] border-[#FFFFFF] z-[2] overflow-hidden">
            <img
              className="object-cover w-full h-full rounded-[10px]"
              src={dataUser[idData].img}
              alt=""
            />
          </div>
          <div className="flex w-[174px] h-[104px] sm:w-[227px] sm:h-[136px] lg:w-[319px] lg:h-[191px] rounded-[10px] z-[1] overflow-hidden ml-[-15px] min-w-[174px] min-h-[104px] sm:min-w-[227px] sm:min-h-[136px] lg:min-w-[319px] lg:min-h-[191px] ">
            <img
              className="object-cover w-full h-full rounded-[10px] brightness-[0.65] "
              src={dataUser[idData === 30 ? 0 : idData + 1].img}
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LifeProContent;

const dataUser = [
  { id: 0, img: imgLC31 },
  { id: 1, img: imgLC1 },
  { id: 2, img: imgLC2 },
  { id: 3, img: imgLC3 },
  { id: 4, img: imgLC4 },
  { id: 5, img: imgLC5 },
  { id: 6, img: imgLC6 },
  { id: 7, img: imgLC7 },
  { id: 8, img: imgLC8 },
  { id: 9, img: imgLC9 },
  { id: 10, img: imgLC10 },
  { id: 11, img: imgLC11 },
  { id: 12, img: imgLC12 },
  { id: 13, img: imgLC13 },
  { id: 14, img: imgLC14 },
  { id: 15, img: imgLC15 },
  { id: 16, img: imgLC16 },
  { id: 17, img: imgLC17 },
  { id: 18, img: imgLC18 },
  { id: 19, img: imgLC19 },
  { id: 20, img: imgLC20 },
  { id: 21, img: imgLC21 },
  { id: 22, img: imgLC22 },
  { id: 23, img: imgLC23 },
  { id: 24, img: imgLC24 },
  { id: 25, img: imgLC25 },
  { id: 26, img: imgLC26 },
  { id: 27, img: imgLC27 },
  { id: 28, img: imgLC28 },
  { id: 29, img: imgLC29 },
  { id: 30, img: imgLC30 },
];

const dataScroll = [
  "CHẾ ĐỘ ĐÃI NGỘ",
  "MÔI TRƯỜNG LÀM VIỆC",
  "GIẢI THƯỞNG",
  "LỘ TRÌNH THĂNG TIẾN",
  "HUẤN LUYỆN ĐÀO TẠO",
];
